import { useContext, useEffect, useState } from 'react'

import { AppContext } from '../components/AppContext/AppContext'
import { MetronomeContext } from '../components/MetronomeContext'

function useUserSwapFee() {
  const {
    state: {
      wallet: { connected, account }
    }
  } = useContext(AppContext)
  const {
    selectedPoolData: {
      fees: { defaultSwapFee }
    },
    metronome
  } = useContext(MetronomeContext)
  const [userSwapFee, setUserSwapFee] = useState(defaultSwapFee)
  // set user's swap fee
  useEffect(
    function () {
      if (metronome && connected) {
        metronome
          .getSwapFeeFor(account)
          .then(sf => setUserSwapFee(sf))
          .catch(() => setUserSwapFee(defaultSwapFee))
      }
    },
    [account, connected, defaultSwapFee, metronome]
  )
  return {
    defaultSwapFee,
    userSwapFee
  }
}

export default useUserSwapFee
